import { api } from '../api';
export interface EstadoMfa {
  estado: 'sem_mfa' | 'inscricao_pendente' | 'ativo';
  exigirMfa: boolean;
  mfaVerificadoEm: string | null;
  mfaAtivadoEm: string | null;
  bloqueadoAte: string | null;
}
export interface DesafioMfa { desafioId: string; expiraEm: string }
export interface InscricaoMfa extends DesafioMfa { segredo: string; otpauthUri: string }
const base = '/api/v1/auth/mfa';
export const estadoMfa = (signal?: AbortSignal) => api<EstadoMfa>(`${base}/estado`, { signal });
export const inscreverMfa = (senhaAtual: string) => api<InscricaoMfa>(`${base}/inscrever`, { method: 'POST', json: { senhaAtual } });
export const criarDesafioMfa = (signal?: AbortSignal) => api<DesafioMfa>(`${base}/desafio`, { method: 'POST', json: {}, signal });
export const confirmarMfa = (codigo: string, desafioId: string) => api<void>(`${base}/confirmar`, { method: 'POST', json: { codigo, desafioId } });
export const verificarMfa = (codigo: string, desafioId: string) => api<void>(`${base}/verificar`, { method: 'POST', json: { codigo, desafioId } });
